import React, { useRef, useEffect, useState } from 'react';
import Headline from '../../partials/Headline';
import Gallery from '../Gallery';
import CertificatesList from './components/CertificatesList';
import cert1 from '../../assets/images/certificates/cert_1.png';

const images = [
  {
    name: 'first Image1',
    url: cert1,
    alt: 'image alt1'
  },
  {
    name: 'first Image2',
    url: cert1,
    alt: 'image alt2'
  },
  {
    name: 'first Image3',
    url: cert1,
    alt: 'image alt3'
  },
  {
    name: 'first Image4',
    url: cert1,
    alt: 'image alt4'
  },
];

const Certificates = () => {
  const certRef = useRef<HTMLDivElement>(null);
  const [ containerWidth, setContainerWidth ] = useState(0);

  useEffect(
    () => {
      setContainerWidth(certRef.current ? certRef.current.offsetWidth : 0);
    },
    [certRef.current],
  )

  return (
    <div className="row certificates" ref={certRef}>
      <div className="container">
        <Headline h={4}>
          Certifikáty
        </Headline>
        <Gallery 
          images={images}
          initialSlide={1}
        />
        <CertificatesList
          containerWidth={containerWidth}
        />
      </div>
    </div>
  );
}

export default Certificates;